import React, { lazy, Component } from 'react';
import { StarIcon } from 'lucide-react';
// Componente de imagen con lazy loading
const LazyImage = ({
  src,
  alt,
  className
}) => {
  return <img src={src} alt={alt} className={className} loading="lazy" data-id="element-241" />;
};
export function Testimonials() {
  return <section id="testimonios" className="py-16 bg-white" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <h2 className="text-3xl font-bold text-center text-amber-800 mb-4" data-id="element-244">
          Lo que dicen otras mamás
        </h2>
        <p className="text-center text-amber-700 mb-12 max-w-2xl mx-auto" data-id="element-245">
          Más de 2,500 mamás ya usan estas recetas y lo confirman:
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-246">
          <TestimonialCard quote="Ahora la cena no me da estrés, ¡hasta disfruto cocinar!" author="María L." location="Madrid" data-id="element-247" />
          <TestimonialCard quote="Mis hijos piden los tacos exprés del ebook todas las semanas." author="Carmen G." location="Sevilla" data-id="element-248" />
          <TestimonialCard quote="Ahorré más dinero del que imaginaba dejando de pedir comida afuera." author="Laura P." location="Barcelona" data-id="element-249" />
        </div>
        <div className="mt-16 flex justify-center" data-id="element-250">
          <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/7AXg44yfDYr9grKTsUgcAT/Generated_Image_September_11%2C_2025_-_3_16PM.png" alt="Mamá cocinando con el libro de recetas" className="w-full max-w-2xl rounded-lg shadow-lg" data-id="element-251" />
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  quote,
  author,
  location
}) {
  return <div className="bg-amber-50 p-6 rounded-lg shadow-md" data-id="element-252">
      <div className="flex mb-4" data-id="element-253">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-500" fill="#f59e0b" data-id="element-254" />)}
      </div>
      <p className="text-amber-800 mb-4 italic" data-id="element-255">"{quote}"</p>
      <div className="text-amber-700" data-id="element-256">
        <p className="font-semibold" data-id="element-257">{author}</p>
        <p className="text-sm" data-id="element-258">{location}</p>
      </div>
    </div>;
}